const Rwd    = require("../utillity/responsive");
const Utill  = require("../utillity/utill");
const Calc   = require('../utillity/calculate');

module.exports.SetSkin = function() {
	let pageJudge = Utill.IsPage('home')||Utill.IsPage('service')||Utill.IsPage('company');
	let color = pageJudge? 'w': 'b';
	// console.log(color)
	this.CtrlSkin( color );
};

module.exports.CtrlSkin = function(logo_color){
	let $h = $('#gHeader');
	let d;

	if( logo_color === undefined ) {
		d = $h.attr('data-color');
		if( d === 'w' ) {
			$h.attr('data-color', 'b');
		}else {
			$h.attr('data-color', 'w');
		}
	}else {
		if( logo_color !== 'b' && logo_color !== 'w' ) {
			// console.log('Error!!');
			return false;
		}

		$h.attr('data-color', logo_color);
	}
};

module.exports.ToggleHamburger = function() {
	let $w = $('#wrapper')
	let condition = $w.attr('data-gNav_condition');
	if ( Rwd.IsMobile() ) {
		Utill.ToggleAttr($w, 'data-gNav_condition', 'open', 'close');
	}else {
		$w.attr('data-gNav_condition', 'open');
	}
};


module.exports.Close = function() {
	if( !Rwd.IsMobile() ) return;

	$('#wrapper').attr('data-gNav_condition', 'close');
};


module.exports.FadeIn = function() {
	TweenMax.to($('#gHeader, .home-pagination, [data-page_controller]'), Calc.ToSecond(450), {
		opacity: 1,
	})
}


module.exports.ControleLogo = function(cuuSecNumber) {
	if( Utill.IsOriginAnime() ) {
		$('.gHeader-logo').removeClass('is-hidden');
	}else {
		if( cuuSecNumber === 0 ) {
			$('.gHeader-logo').removeClass('is-hidden');
		}else {
			$('.gHeader-logo').addClass('is-hidden');
		}
	}
};


// WEBPACK FOOTER //
// ./html/_src/js_wb/dom/header.js